import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})

export class CartComponent implements OnInit {

  offerChoosed:any;

  inter:any;

  isActive:boolean;

  constructor(public api:ApiService) { }

  ngOnInit() {
    this.inter = setInterval(()=>{
      try{
        if(this.api.order.prods.length > 0)
          localStorage.setItem('brgProOrder',JSON.stringify(this.api.order));
      }catch(e){

      }
    },2000);
  }

  chooseOffer(){


    if(this.offerChoosed === undefined){
      this.api.addToCart(this.api.selectedProduct);
      this.api.changeQty(this.api.selectedProduct);
    }else{
      let o = Object.assign({}, this.offerChoosed);
      o.acceptedForProds.push(this.api.selectedProduct.Id);
      if(o.baseQty < 1 && o.field != null)
        o.baseQty = parseInt(this.api.selectedProduct[o.field]);
      this.api.addToCart(this.api.selectedProduct);
      this.api.selectedProduct.quantity = parseInt(o.baseQty);
      this.api.changeQty(this.api.selectedProduct);
    }
  }

  evalReturn(str){
    return eval("`"+str+"`");
  }

  ngOnDestroy(){
    clearInterval(this.inter);
  }
}
